export const barChartBackground = '#fcc468';

export const doughnutChartBackground1 = '#fcc468';
export const doughnutChartBackground2 = '#51cbce';
export const doughnutChartBackground3 = '#6bd098';
